import Cookie from 'js-cookie'
import cookieConfig from '../config/cookie'

/**
 * Cookie管理工具类
 * 解决多个网站Cookie冲突问题
 */
class CookieManager {
  constructor(appName = cookieConfig.appName) {
    this.appName = appName
    this.prefix = `${appName}_`
    this.config = cookieConfig
  }

  /**
   * 获取Cookie配置
   * @param {Object} options 额外配置
   * @returns {Object} Cookie配置对象
   */
  getCookieOptions(options = {}) {
    return {
      expires: 1, // 1天过期
      secure: this.config.secure, // 根据配置决定是否使用HTTPS
      sameSite: this.config.sameSite, // 根据配置设置sameSite
      domain: this.config.domain, // 使用配置的域名
      path: '/', // 设置路径范围
      ...options
    }
  }

  /**
   * 设置Cookie
   * @param {string} key Cookie键名
   * @param {string} value Cookie值
   * @param {Object} options 配置选项
   */
  set(key, value, options = {}) {
    const cookieKey = this.prefix + key
    const cookieOptions = this.getCookieOptions(options)
    Cookie.set(cookieKey, value, cookieOptions)
  }

  /**
   * 获取Cookie
   * @param {string} key Cookie键名
   * @returns {string|undefined} Cookie值
   */
  get(key) {
    const cookieKey = this.prefix + key
    return Cookie.get(cookieKey)
  }

  /**
   * 删除Cookie
   * @param {string} key Cookie键名
   */
  remove(key) {
    const cookieKey = this.prefix + key
    const cookieOptions = this.getCookieOptions()
    Cookie.remove(cookieKey, cookieOptions)
  }

  /**
   * 检查Cookie是否存在
   * @param {string} key Cookie键名
   * @returns {boolean} 是否存在
   */
  has(key) {
    return this.get(key) !== undefined
  }

  /**
   * 获取所有当前应用的Cookie
   * @returns {Object} 所有Cookie对象
   */
  getAll() {
    const allCookies = Cookie.get()
    const appCookies = {}
    
    Object.keys(allCookies).forEach(key => {
      if (key.startsWith(this.prefix)) {
        const originalKey = key.replace(this.prefix, '')
        appCookies[originalKey] = allCookies[key]
      }
    })
    
    return appCookies
  }

  /**
   * 清除所有当前应用的Cookie
   */
  clearAll() {
    const allCookies = this.getAll()
    Object.keys(allCookies).forEach(key => {
      this.remove(key)
    })
  }

  /**
   * 获取Cookie存储大小（字节）
   * @returns {number} 存储大小
   */
  getStorageSize() {
    const allCookies = this.getAll()
    let size = 0
    
    Object.keys(allCookies).forEach(key => {
      const value = allCookies[key]
      size += key.length + value.length
    })
    
    return size
  }

  /**
   * 获取当前应用的Cookie信息
   * @returns {Object} Cookie信息
   */
  getInfo() {
    return {
      appName: this.appName,
      prefix: this.prefix,
      config: this.config,
      cookies: this.getAll(),
      size: this.getStorageSize()
    }
  }
}

// 创建默认实例
const cookieManager = new CookieManager()

export default cookieManager
export { CookieManager } 